import React from 'react';
import './bravo.scss';

export default BravoTheme;

export function BravoTheme() {
  return null;
}
